<template>
	<div class="main-content">
		<el-form :model="ruleForm" :rules="rules" status-icon ref="ruleForm" label-width="100px" class="reset-ruleForm">
			<el-form-item label="旧密码" prop="old_password">
				<el-input type="password" v-model="ruleForm.old_password" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="pass">
				<el-input type="password" v-model="ruleForm.pass" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="checkPass">
				<el-input type="password" v-model="ruleForm.checkPass" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button @click="submitForm()" class="submit-reset" style="background: #409EFF;color: #fff;">确认修改</el-button>
			</el-form-item>

		</el-form>
	</div>
</template>

<script >
	import https from '../https.js'
	export default {

		data() {

			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				}else if(value.length<6){
					callback(new Error('密码需要六位数以上'));
				}
				 else {

					callback();
				}
			};
			var validateoldPass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入旧密码'));
				} else {

					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}

			};
			return {
				activeName: 'second',
				ruleForm: {
					pass: '',
					checkPass: '',
					old_password: ''
				},
				rules: {
					old_password: [{
						required: true,
						validator: validateoldPass,
						trigger: 'blur'
					}],
					pass: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					}],
				}
			};
		},

		methods: {
			submitForm() {
				if (this.ruleForm.old_password == '') {
					this.$message({
						type: 'warning',
						message: '请输入旧密码'
					});
					return;
				}
				if (this.ruleForm.checkPass == ''||this.ruleForm.pass=='') {
					this.$message({
						type: 'warning',
						message: '请输入新密码'
					});
					return;
				}
				if(this.ruleForm.checkPass!=this.ruleForm.pass){
					this.$message({
						type:'warning',
						message:'两次输入密码不一致'
					})
					return;
				}
				if(this.ruleForm.checkPass.length<6){
					this.$message({
						type:'warning',
						message:'密码需要六位数以上'
					})
					return;
				}
				var params = {
					old_password: this.ruleForm.old_password,
					new_password: this.ruleForm.checkPass
				}
				https.fetchPost('/pc/service/user/default/reset-password', params).then((res) => {
					localStorage.removeItem('authorization');
					localStorage.removeItem('CLIENT_EXPIRES');
					localStorage.removeItem('fullname');
					if (res.data.success) {
						this.$alert('密码修改成功', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								this.$router.push('login');
							}
						});
					}
				}).catch(err => {
					console.log(err)
				})

			},

		}

	}
</script>
<style scoped="">
	.reset-ruleForm {
		width: 400px;
		margin: 0 auto;
		padding-top: 200px;
	}

	.submit-reset {
		width: 100%;
		background: #409EFF;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/views/resetpwd.vue